<template>
  <span>
    <span class="ui-text-clickable" @click="isDialogOpen = true">Add New</span>
    <hi-dialog
      v-model="isDialogOpen"
      title="Create New SMS Campaign"
      @submit="submit"
      :submit-disabled="!campaignName || !campaignName.length"
      :error="error"
    >
      <v-text-field
        v-model="campaignName"
        label="Campaign Name"
        ref="input"
      ></v-text-field>
    </hi-dialog>
  </span>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { DocHelper } from "@/db";
export default {
  name: "NewSmsCampaign",
  components: { HiDialog },
  data() {
    return {
      isDialogOpen: false,
      campaignName: null,
      error: null
    };
  },
  methods: {
    async submit() {
      try {
        await DocHelper.newDoc("sms/bulk/campaigns", {
          name: this.campaignName
        });
        this.isDialogOpen = false;
      } catch (e) {
        this.error = e.message;
      }
    }
  }
};
</script>

<style scoped></style>
